/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { fireScreenAnalytics, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { sendPendoTrackEvent } from './sendPendoTrackEvent.tsx';

export const ListView = {
	opened: (event: UIAnalyticsEvent, accessLevel?: string): void => {
		// https://app.pendo.io/s/4758009750487040/trackevents/M2-9XepSbr5FNP9yFynxrzIQUZQ
		sendPendoTrackEvent({
			actionSubjectAndAction: 'listView opened',
			attributes: { accessLevel: accessLevel || '' },
		});

		// https://data-portal.internal.atlassian.com/analytics/registry/51087
		fireScreenAnalytics(event, { accessLevel });
	},
	fieldValueUpdatedByDragBetweenSwimlanes: (fieldType: string | undefined): void => {
		sendPendoTrackEvent(`fieldValue updated ${fieldType} listDragBetweenSwimlanes`);
	},
	fieldValueUpdatedByInlineEdit: (fieldType: string | undefined): void => {
		sendPendoTrackEvent(`fieldValue updated ${fieldType} listInlineEdit`);
	},
	columnActionItemClicked: (
		event: UIAnalyticsEvent,
		attributes: { selectedActionItem: string },
	): void => {
		sendPendoTrackEvent(`listViewColumnActionItem ${attributes.selectedActionItem}`);

		fireUIAnalytics(event, 'dropdownItem clicked', 'viewFieldActions', attributes);
	},
	learnMoreAboutArchiveButtonClicked: (event: UIAnalyticsEvent): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/56971
		fireUIAnalytics(event, 'button clicked', 'learnMoreAboutArchivingIdeas', {});
	},
	addIdeaFixedBottomRowClicked: (event: UIAnalyticsEvent, grouped: string): void => {
		// https://data-portal.internal.atlassian.com/analytics/registry/75128
		fireUIAnalytics(event, 'button clicked', 'addIdeaFixedRow', {
			grouped,
		});
	},
};
